import { methods as addressesMethods } from 'utils/addresses';
import moment from 'moment-timezone';

const getTimesFromShipment = (shipment) => {
  const {
    pickup_date_from,
    pickup_date_to,
    pickup_time_from,
    pickup_time_to,

    dropoff_date_from,
    dropoff_date_to,
    dropoff_time_from,
    dropoff_time_to,

    address_from,
    address_to,
  } = shipment;

  return {
    pickup_date_from,
    pickup_date_to,
    pickup_time_from,
    pickup_time_to,
    dropoff_date_from,
    dropoff_date_to,
    dropoff_time_from,
    dropoff_time_to,

    pickup_timezone:
      addressesMethods.getTimezoneOfAddress(address_from) || moment.tz.guess(),
    dropoff_timezone:
      addressesMethods.getTimezoneOfAddress(address_to) || moment.tz.guess(),
  };
};

export default getTimesFromShipment;
